import PropTypes from 'prop-types';
import { Box, Typography, Stack } from '@mui/material';

export default function HRPageHeader({ title, description, actions, sx }) {
  return (
    <Box
      sx={{
        mb: 3,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'flex-start' },
        justifyContent: 'space-between',
        gap: 2,
        ...sx,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, maxWidth: 720 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 700, mb: description ? 1 : 0 }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.65 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap sx={{ flexShrink: 0 }}>
          {actions}
        </Stack>
      )}
    </Box>
  );
}

HRPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  sx: PropTypes.object,
};
